import { format } from "date-fns";
import { toZonedTime } from "date-fns-tz";
const timeZone = "Asia/Kolkata";

export const formatDate = (dateStr) => {
  const date = new Date(dateStr);
  return date.toLocaleDateString('en-GB', {
    day: '2-digit',
    month: 'short',
    year: '2-digit',
  });
};

export const getNightDayDuration = (start, end) => {
  const startDate = new Date(start);
  const endDate = new Date(end);

  const diffTime = endDate - startDate;
  const totalDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24)) + 1; // +1 to include end date
  const nights = totalDays - 1;

  return `${nights} Night${nights > 1 ? 's' : ''} , ${totalDays} Day${totalDays > 1 ? 's' : ''}`;
};

export const formatDateMonthYear = (timestamp) => {
  if (!timestamp) return ""; // Handle invalid or empty timestamps

  const ts = String(timestamp).length === 10 ? timestamp * 1000 : timestamp;
  const date = new Date(ts);

  return date.toLocaleDateString('en-US', {
    month: 'short',
    year: 'numeric',
  });
};

export const todayIST = new Date().toLocaleDateString('en-CA', {
  timeZone: 'Asia/Kolkata'  // IST
});
//Example "May 24, 2025 at 5:42 PM"
export const getFormattedDateTime = () => {
  const now = new Date();

  const dateOptions = {
    year: "numeric",
    month: "long",
    day: "numeric",
  };

  const timeOptions = {
    hour: "numeric",
    minute: "2-digit",
    hour12: true,
  };

  const datePart = now.toLocaleDateString("en-US", dateOptions);
  const timePart = now.toLocaleTimeString("en-US", timeOptions);

  return `${datePart} at ${timePart}`;
}




export const validateFile = (file) => {
  const allowedTypes = ["image/jpeg", "image/jpg", "image/png"];
  const maxSize = 250 * 1024; // 250KB

  if (!file) return "No file selected";
  if (!allowedTypes.includes(file.type)) return "Only JPG, JPEG, PNG allowed";
  if (file.size > maxSize) return "File size must be under 250KB";
  return null;
};

export const formatMessageTime = (timestampInSeconds) => {
  if (!timestampInSeconds || isNaN(timestampInSeconds)) return "";

  const timestampMs = Number(timestampInSeconds) * 1000;
  const date = new Date(timestampMs);

  if (isNaN(date.getTime())) return "";

  // Format day, month parts manually (e.g., "12 Jun")
  const dateParts = new Intl.DateTimeFormat("en-US", {
    timeZone: "Asia/Kolkata",
    day: "2-digit",
    month: "short",
  }).formatToParts(date);

  const day = dateParts.find(p => p.type === "day")?.value;
  const month = dateParts.find(p => p.type === "month")?.value;

  // Format time (e.g., "12:32 PM")
  const timeStr = new Intl.DateTimeFormat("en-US", {
    timeZone: "Asia/Kolkata",
    hour: "2-digit",
    minute: "2-digit",
    hour12: true,
  }).format(date);

  // Check if it's today
  const today = new Date();
  const todayStr = new Intl.DateTimeFormat("en-CA", {
    timeZone: "Asia/Kolkata",
    year: "numeric",
    month: "2-digit",
    day: "2-digit",
  }).format(today);

  const messageStr = new Intl.DateTimeFormat("en-CA", {
    timeZone: "Asia/Kolkata",
    year: "numeric",
    month: "2-digit",
    day: "2-digit",
  }).format(date);

  if (todayStr === messageStr) {
    return timeStr; // Today: show only time
  }

  return `${timeStr}`; // → "12 Jun, 12:32 PM"
};

export const formatMessageTime1 = (timestampInSeconds) => {
  if (!timestampInSeconds || isNaN(timestampInSeconds)) return "";

  const timestampMs = Number(timestampInSeconds) * 1000;
  const date = new Date(timestampMs);

  if (isNaN(date.getTime())) return "";

  // Format day, month parts manually (e.g., "12 Jun")
  const dateParts = new Intl.DateTimeFormat("en-US", {
    timeZone: "Asia/Kolkata",
    day: "2-digit",
    month: "short",
  }).formatToParts(date);

  const day = dateParts.find(p => p.type === "day")?.value;
  const month = dateParts.find(p => p.type === "month")?.value;

  // Format time (e.g., "12:32 PM")
  const timeStr = new Intl.DateTimeFormat("en-US", {
    timeZone: "Asia/Kolkata",
    hour: "2-digit",
    minute: "2-digit",
    hour12: true,
  }).format(date);

  // Check if it's today
  const today = new Date();
  const todayStr = new Intl.DateTimeFormat("en-CA", {
    timeZone: "Asia/Kolkata",
    year: "numeric",
    month: "2-digit",
    day: "2-digit",
  }).format(today);

  const messageStr = new Intl.DateTimeFormat("en-CA", {
    timeZone: "Asia/Kolkata",
    year: "numeric",
    month: "2-digit",
    day: "2-digit",
  }).format(date);

  // if (todayStr === messageStr) {
  //   return timeStr; // Today: show only time
  // }

  return `${day} ${month}, ${timeStr}`; // → "12 Jun, 12:32 PM"
};



export const getDateGroupLabel = (timestampInSeconds) => {
  const now = toZonedTime(new Date(), timeZone);
  const date = toZonedTime(new Date(timestampInSeconds * 1000), timeZone);

  const todayStr = format(now, "yyyy-MM-dd");
  const yesterdayStr = format(new Date(now.setDate(now.getDate() - 1)), "yyyy-MM-dd");
  const messageStr = format(date, "yyyy-MM-dd");

  if (messageStr === todayStr) return "Today";
  if (messageStr === yesterdayStr) return "Yesterday";
  return format(date, "dd MMMM yyyy"); // e.g., "06 June 2025"
};
 export const groupMessagesByDate = (messages) => {
  return messages.reduce((acc, msg) => {
    const label = getDateGroupLabel(msg.message_datetime);
    if (!acc[label]) acc[label] = [];
    acc[label].push(msg);
    return acc;
  }, {});
};